import { render, staticRenderFns } from "./loader-query-product.vue?vue&type=template&id=353b6b60&scoped=true&"
import script from "./loader-query-product.vue?vue&type=script&lang=js&"
export * from "./loader-query-product.vue?vue&type=script&lang=js&"
import style0 from "./loader-query-product.vue?vue&type=style&index=0&id=353b6b60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353b6b60",
  null
  
)

export default component.exports